/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import { SharedTrialOfferProps, TrialOffer } from '../TrialOffer';

/**
 * Offers the opportunity to start a Company trial.
 */
export const CompanyTrialOffer = (props: SharedTrialOfferProps) => (
  <TrialOffer
    description="Create and manage multiples teams across your entire company. Add a layer of security with advanced Admin Features (SSO, Governance, Data Rentention, and more)."
    features={[
      { iconName: 'miscBolt', label: 'Unlimited Zaps' },
      { iconName: 'team', label: 'Unlimited users and teams' },
      { iconName: 'miscClock', label: 'Our fastest update times' },
      { iconName: 'miscHeadset', label: 'Dedicated Premier Support Team' },
    ]}
    fullStoryEventName="Viewed Company Trial Offer"
    title="Try Zapier for Companies"
    trialType="Company"
    {...props}
  />
);
